import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

export function initNewsSlider() {
  const sectionEl = document.querySelector('.home-news');
  if (!sectionEl) {
    return;
  }

  const sliderEl = sectionEl.querySelector('.home-news__slider');
  if (!sliderEl) {
    return;
  }

  const slides = sliderEl.querySelectorAll('.swiper-slide');
  if (slides.length <= 1) {
    return;
  }

  const prevBtn = sectionEl.querySelector('.home-news__nav-btn--prev');
  const nextBtn = sectionEl.querySelector('.home-news__nav-btn--next');

  // Na tablecie+ (≥768px) działamy jako CSS Grid – Swiper musi być wyłączony
  const TABLET_BREAKPOINT = 768;

  let swiper = null;

  function mountSwiper() {
    if (swiper) return;
    swiper = new Swiper(sliderEl, {
      modules: [Navigation, A11y, Keyboard],
      slidesPerView: 1,
      spaceBetween: 24,
      speed: 500,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        prevSlideMessage: 'Poprzedni wpis',
        nextSlideMessage: 'Następny wpis',
        firstSlideMessage: 'To jest pierwszy wpis',
        lastSlideMessage: 'To jest ostatni wpis',
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
    });
  }

  function destroySwiper() {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
  }

  function handleResize() {
    if (window.innerWidth < TABLET_BREAKPOINT) {
      mountSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
}
